const media = "_35sm1gi5lxs";
const textContent = "_35st1g0ou94";
const readOutLoudButtonWrapper = "_35srtjvvki";

export { media, readOutLoudButtonWrapper, textContent };
import "./shared.style.linaria.module.css";
//# sourceMappingURL=shared.style.js.map
